import styled from "styled-components";

export const CostParagraph = styled.p`
  font-size: 18px;
  word-break: break-word;
  @media (min-width: 500px) {
    font-size: ${({ theme }) => theme.fontSize.xl};
  }
  color: ${({ theme }) => theme.colors.dark};
  font-family: JetBrains Mono;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-top: 1em;
  margin-bottom: 1em;
`;
